import React, { useContext } from 'react'
import {
    Stack,
    Box,
    Typography
} from '@mui/material'

import { AppContext } from './../../context/context/context.js'

import data from '../../data/about.json'

const About = () => {
    const { state } = useContext(AppContext)

    const aboutImg = 'https://firebasestorage.googleapis.com/v0/b/elaraby-photographer.appspot.com/o/about.webp?alt=media&token=f4b230ca-09c5-4456-ad39-93f24c775a39'

    return (
        <Box padding="3% 5% 0%">
            <Stack
                data-aos="fade-up"
                direction={{ xs: 'column', md: 'row' }}
                spacing={{ xs: 7, md: 4 }}
                justifyContent="space-around"
                alignItems="center"
            >
                <Box
                    sx={{ width: { xs: "90%", md: "40%" }, }}
                    component='img'
                    src={aboutImg}
                    alt={data.name}
                />
                <Stack
                    direction={{ xs: 'column' }}
                    spacing={{ xs: 1, sm: 2, md: 4 }}
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                        width: { xs: "90%", md: "50%" },
                        alignItems: { xs: 'center', md: "flex-start" }
                    }}
                >
                    <Typography
                        variant="h1"
                        gutterBottom
                        fontFamily={"Montserrat, sans-serif"}
                        sx={{
                            color: state.color.dark,
                            fontWeight: 900,
                            fontSize: { xs: 24, sm: 36, md: 44, lg: 50 },
                        }}
                    >
                        {data.name}
                    </Typography>
                    <Box sx={{ alignItems: { xs: 'center', md: "flex-start" } }}>
                        <Typography
                            variant="p"
                            gutterBottom
                            fontFamily={"Montserrat, sans-serif"}>
                            {data.data}
                        </Typography>
                    </Box>
                </Stack>
            </Stack >
        </Box >
    )
}

export default About